export function smoothScrollOnPageLoad() {
  var win = window,
      doc = document,
      $ = jQuery; // remove any CSS smooth-scroll.

  $('html').css('scroll-behavior', 'auto');
  setTimeout(doSmoothScroll, 1000);

  function doSmoothScroll() {
    // Smooth scroll on page load if the URL has a fragment identifier
    if (win.location.hash) {
      // Hash
      var _hash = win.location.hash; // Element with the id corresponding to the hash fragment exists

      if (doc.getElementById(_hash.replace("#", ""))) {
        var $siteheader = $(".site-header").height();
        doc.addEventListener("DOMContentLoaded", function () {
          if (Foundation.SmoothScroll) {
            var smoothScrollOptions = {
              animationDuration: 500,
              animationEasing: "linear",
              threshold: 50,
              offset: $(".site-header").height()
            };
            Foundation.SmoothScroll.scrollToLoc(_hash, smoothScrollOptions, function () {
              // Add CSS smooth-scroll.
              $('html').css('scroll-behavior', 'smooth');
              console.log("Scroll Complete");
            });
          }
        });
      }
    } else {
      $('html').css('scroll-behavior', 'smooth');
    }
  }
}